<div class="deck">
  <app-swipe-card
    *ngFor="let profile of profiles.slice(0, maxVisible); let i = index; trackBy: trackById"
    class="card"
    [profile]="profile"
    [stackIndex]="i"
    [isTop]="i === 0"
    [deckDx]="deckDx()"
    [deckDy]="deckDy()"
    [deckDragging]="deckDragging()"
    (deckOffsetChange)="onDeckOffsetChange($event, i)"
    (deckDragActiveChange)="onDeckDragActiveChange($event, i)"
    (decision)="onDecision($event)"
    (superLike)="superLike.emit($event)"
  />
</div>

